import { apiFetch } from "./api.js";
import { trackEvent } from "../lib/analytics.js";

/** Get all active rewards. Returns merged seed + admin-added list. */
export async function getRewards() {
  return apiFetch("/api/rewards");
}

/** Create a new reward (admin only). */
export async function createReward(reward) {
  return apiFetch("/api/rewards", {
    method: "POST",
    body: JSON.stringify(reward),
  });
}

/** Update a reward (admin only). */
export async function updateReward(id, updates) {
  return apiFetch(`/api/rewards/${id}`, {
    method: "PATCH",
    body: JSON.stringify(updates),
  });
}

/** Soft-delete a reward (admin only). */
export async function deleteReward(id) {
  return apiFetch(`/api/rewards/${id}`, { method: "DELETE" });
}

/**
 * Redeem a reward.
 * VOTER-ID: API resolves voter from JWT. Phone is optional (legacy compat / admin).
 * v1.28.3: airtime redemptions must include `network` — the user-picked
 * carrier from the /api/redemptions/networks list. Other categories
 * (voucher, data, etc.) omit the field.
 * Returns { balance: number } — updated XP balance.
 */
export async function redeemReward(rewardId, phone, network) {
  const result = await apiFetch("/api/redemptions", {
    method: "POST",
    body: JSON.stringify({
      rewardId,
      ...(phone ? { phone } : {}),
      ...(network ? { network } : {}),
    }),
  });
  trackEvent("reward_redeemed", { reward_id: rewardId });
  return result;
}

/**
 * v1.28.3 — list airtime networks available via OgaRecharge. Used to
 * populate the network picker in the redemption modal. Returns an array
 * of { name, type, code }. Empty array on failure so the UI can degrade
 * gracefully rather than blocking the whole shop.
 */
export async function getRedemptionNetworks() {
  try {
    const res = await apiFetch("/api/redemptions/networks");
    return Array.isArray(res?.networks) ? res.networks : [];
  } catch {
    return [];
  }
}
